const services = [
  {
    title: 'Robotics Consulting',
    description: 'System architecture, technical review, and deployment guidance for robotics programs that need expert engineering support at any stage.',
  },
  {
    title: 'Physical AI Consulting',
    description: 'Applied expertise in perception, embodied intelligence, and real-world AI systems built for physical environments and operational constraints.',
  },
  {
    title: 'International Infrastructure Advisory',
    description: 'Cross-border engineering coordination and expert-led review for infrastructure, safety, and technical validation work across jurisdictions.',
  },
];

export default function Services() {
  return (
    <section id="services" className="py-24 px-6 bg-white">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-700 tracking-tight text-brand-text mb-16">What we do</h2>
        <div className="grid md:grid-cols-3 gap-10">
          {services.map(s => (
            <div key={s.title} className="flex flex-col gap-4 border-t border-brand-gray pt-8">
              <h3 className="text-lg font-600 text-brand-text">{s.title}</h3>
              <p className="text-sm text-brand-text/60 leading-relaxed flex-1">{s.description}</p>
              <a href="#contact" className="text-sm font-medium text-brand-blue hover:underline">Learn more →</a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
